import AbstractRightAngledTriangle from "./AbstractRightAngledTriangle";

export default class RightAngledTriangle extends AbstractRightAngledTriangle {
	static NAME = "right-angled-triangle";

	get_name() {
		return RightAngledTriangle.NAME;
	}

}
